import { atom } from 'recoil'

export const isOpenSaveConfigState = atom({
  key: 'isOpenSaveProspectConfigState',
  default: false
})

export const isLoadingSaveConfigState = atom({
  key: 'isLoadingSaveProspectConfigState',
  default: false
})
